module.exports = __webpack_public_path__ + "img/facebook-icon.6067bff6.svg";